import { Brand, createBranded } from '@deltasierra/type-utilities';

export type CrmRecipientListFilterId = Brand<number, 'CrmRecipientListFilterId'>;
export const CrmRecipientListFilterId = createBranded<CrmRecipientListFilterId>();
